import { createAction } from 'Lib/reduxUtils';

import { SET_APPEALS_MODAL_FYI_VIEWED, SET_BAN_POLICY } from 'Store/appeals/constants';
import { BanPolicy } from 'Store/appeals/types';

export const setAppealsModalFYIViewedAt = createAction(
  SET_APPEALS_MODAL_FYI_VIEWED,
  (payload: { modalFYIviewedAt: number }) => payload
);

export const setBanPolicy = createAction(
  SET_BAN_POLICY,
  (payload: BanPolicy | null) => payload || null
);
